import React from "react";

const PriceModal = ({
  isOpen,
  onClose,
  priceType,
  updatedPrices,
  handleColorTypeChange,
  handleCombinationPriceChange,
  updatePrices,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-gray-900 bg-opacity-50 p-4">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl overflow-hidden">
        <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
          <h3 className="text-xl font-semibold text-gray-800">
            Update {priceType.toUpperCase()} Prices - Combination Pricing
          </h3>
          <p className="text-sm text-gray-500 mt-1">
            Set prices for specific combinations of options
          </p>
        </div>

        <div className="p-6 overflow-y-auto max-h-[70vh]">
          <div className="flex mb-6 border-b border-gray-200">
            {["Black & White", "Color"].map((colorType) => (
              <button
                key={colorType}
                className={`px-4 py-2 font-medium text-sm ${
                  updatedPrices[priceType].currentColorType === colorType
                    ? "border-b-2 border-blue-500 text-blue-600"
                    : "text-gray-500 hover:text-gray-700"
                }`}
                onClick={() => handleColorTypeChange(colorType)}
              >
                {colorType}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {["70GSM Paper", "100GSM Paper", "Bond Paper", "Cartridge Paper", "Glossy Paper"].map(
              (paperType) => (
                <div key={paperType} className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-medium text-gray-700 mb-3">{paperType}</h4>

                  <div className="space-y-4">
                    {["A4", "A3"].map((paperSize) => (
                      <div key={paperSize} className="space-y-2">
                        <h5 className="text-sm font-medium text-gray-600">{paperSize}</h5>

                        <div className="grid grid-cols-3 gap-2">
                          {(priceType === "ppt" ? [1, 2, 4] : [1, 2, 4, 6, 9]).map((pages) => {
                            const comboKey = `${paperType}_${paperSize}_${pages}`;
                            return (
                              <div key={pages} className="flex flex-col">
                                <label className="text-xs text-gray-500 mb-1">
                                  {pages} pg/sheet
                                </label>
                                <div className="flex items-center">
                                  <span className="mr-1 text-sm">₹</span>
                                  <input
                                    type="number"
                                    step="0.5"
                                    value={
                                      updatedPrices[priceType][
                                        updatedPrices[priceType].currentColorType
                                      ]?.[comboKey] || ""
                                    }
                                    onChange={(e) =>
                                      handleCombinationPriceChange(
                                        paperType,
                                        paperSize,
                                        pages,
                                        e.target.value
                                      )
                                    }
                                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )
            )}
          </div>
        </div>

        <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={updatePrices}
            className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700"
          >
            Save All Prices
          </button>
        </div>
      </div>
    </div>
  );
};

export default PriceModal;
